import React from 'react'
import { Pane } from 'evergreen-ui'

export default () => <Pane width='2px' background='rgba(255, 255, 255, 0.2)' />